import { userReducer } from './userReducer';

export const reducersRaw = { user: userReducer };
